export const SAVE_ERROR_MESSAGE = 'Something went wrong while attempting to save your changes, click save to try again';
